import Marquee from 'react-fast-marquee';
import { 
  FaGoogle, 
  FaMicrosoft, 
  FaAirbnb, 
  FaSpotify, 
  FaSlack, 
  FaHubspot,
  FaSalesforce,
  FaAmazon,
  FaLinkedin
} from 'react-icons/fa';
import { SiNotion, SiAsana, SiZoom } from 'react-icons/si';

const TrustSectionV2 = () => {
  const logos = [
    { Icon: FaGoogle, name: 'Google', color: '#5B8FB9' },
    { Icon: FaMicrosoft, name: 'Microsoft', color: '#7CB98F' },
    { Icon: FaAirbnb, name: 'Airbnb', color: '#D4A5B5' },
    { Icon: FaSpotify, name: 'Spotify', color: '#5B8FB9' },
    { Icon: FaSlack, name: 'Slack', color: '#7CB98F' },
    { Icon: FaHubspot, name: 'HubSpot', color: '#D4A5B5' },
    { Icon: FaSalesforce, name: 'Salesforce', color: '#5B8FB9' },
    { Icon: FaAmazon, name: 'Amazon', color: '#7CB98F' },
    { Icon: SiNotion, name: 'Notion', color: '#D4A5B5' },
    { Icon: SiAsana, name: 'Asana', color: '#5B8FB9' },
    { Icon: SiZoom, name: 'Zoom', color: '#7CB98F' },
    { Icon: FaLinkedin, name: 'LinkedIn', color: '#D4A5B5' },
  ];

  return (
    <section
      id="trust"
      data-testid="trust-section-v2"
      className="py-16 md:py-20 bg-gradient-to-r from-[#5B8FB9]/5 via-[#7CB98F]/5 to-[#D4A5B5]/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-10">
        <p className="text-center text-gray-600 text-base font-light" data-testid="trust-headline-v2">
          Trusted by professionals and organizations seeking sustainable growth, 
          stronger leadership, and healthier work environments.
        </p>
      </div>

      <Marquee
        gradient={true}
        gradientColor="#fafcfb"
        gradientWidth={100}
        speed={30}
        pauseOnHover={true}
      >
        {logos.map(({ Icon, name, color }, index) => (
          <div
            key={index}
            className="mx-12 flex items-center gap-2 transition-all duration-300 hover:scale-110"
            style={{ color: `${color}60` }}
            data-testid={`trust-logo-v2-${name.toLowerCase()}`}
          >
            <Icon size={28} className="hover:opacity-100 transition-opacity" style={{ color }} />
            <span className="text-sm font-medium hidden sm:inline text-gray-500">{name}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default TrustSectionV2;
